import { Grid } from "@mui/material";
import { StyledLinkSpan, StyledTextSpan } from "../styled-components/StyledConsentSpan";

/**
 * UK-only legal term for the account-type selection page. UK compliance
 * feedback replaced the consent tick box + AppFormLegalTerm wording with this
 * single always-visible line; other regions keep AppFormLegalTerm as is.
 */
export default function UkAppFormLegalTerm() {
  return (
    <Grid item xs={12}>
      <StyledTextSpan>
        By clicking <span style={{ color: "#FC4C4C" }}>Next</span>, you agree to Caleb & Brown’s{" "}
        <StyledLinkSpan href="https://calebandbrown.com/terms-of-business" target="_blank">
          Terms of Business
        </StyledLinkSpan>{" "}
        and{" "}
        <StyledLinkSpan href="https://calebandbrown.com/website-terms-of-use/" target="_blank">
          Website Terms of Use
        </StyledLinkSpan>
        . Personal information is collected and handled for purposes described and in accordance
        with Caleb & Brown’s{" "}
        <StyledLinkSpan href="https://calebandbrown.com/privacy-policy/" target="_blank">
          Privacy Policy
        </StyledLinkSpan>
        .
      </StyledTextSpan>
      <br />
      <br />
    </Grid>
  );
}
